// components
import DateFieldIndicator from '@/vue3/components/table-plugins/DateFieldIndicator.vue';
const defaultFilterMethod = { value: 'contains', label: 'Contains' };

export default [
    {
        field: 'id',
        header: 'Id',
        sortable: true,
        filterMethod: defaultFilterMethod,
        isFilterVisible: false,
        width: '60px',
    },
    {
        field: 'title',
        header: 'Title',
        sortable: true,
        filterMethod: defaultFilterMethod,
        isFilterVisible: false,
        width: '100px',
    },
    {
        field: 'geoRecordCategory',
        header: 'Category',
        sortable: true,
        filterMethod: defaultFilterMethod,
        isFilterVisible: false,
        width: '120px',
    },
    {
        field: 'tagName',
        header: 'Tags',
        sortable: true,
        filterMethod: defaultFilterMethod,
        isFilterVisible: false,
        width: '100px',
    },
    {
        field: 'projectName',
        header: 'Project',
        sortable: true,
        filterMethod: defaultFilterMethod,
        isFilterVisible: false,
        width: '100px',
    },
    {
        field: 'notes',
        header: 'Notes',
        sortable: true,
        filterMethod: defaultFilterMethod,
        isFilterVisible: false,
        width: '100px',
    },
    {
        field: 'created',
        header: 'Created',
        sortable: true,
        filterMethod: defaultFilterMethod,
        isFilterVisible: false,
        width: '80px',
        cellRenderer: DateFieldIndicator,
        cellRendererProps: { dateField: 'created' },
    },
    {
        field: 'creator',
        header: 'Creator',
        sortable: true,
        filterMethod: defaultFilterMethod,
        isFilterVisible: false,
        width: '100px',
    },
    {
        field: 'holes',
        header: 'Holes',
        sortable: true,
        filterMethod: defaultFilterMethod,
        isFilterVisible: false,
        width: '100px',
    },
    {
        field: 'status',
        header: 'Status',
        sortable: true,
        filterMethod: defaultFilterMethod,
        isFilterVisible: false,
        width: '120px',
    },
    {
        field: 'isPrivate',
        header: 'isPrivate',
        sortable: true,
        filterMethod: defaultFilterMethod,
        isFilterVisible: false,
        width: '120px',
    },
    {
        field: 'startDate',
        header: 'Start Date',
        sortable: true,
        filterMethod: defaultFilterMethod,
        isFilterVisible: false,
        width: '130px',
        cellRenderer: DateFieldIndicator,
        cellRendererProps: { dateField: 'startDate' },
    },
    {
        field: 'dueDate',
        header: 'Due Date',
        sortable: true,
        filterMethod: defaultFilterMethod,
        isFilterVisible: false,
        width: '120px',
        cellRenderer: DateFieldIndicator,
        cellRendererProps: { dateField: 'dueDate' },
    },
    {
        field: 'endDate',
        header: 'End Date',
        sortable: true,
        filterMethod: defaultFilterMethod,
        isFilterVisible: false,
        width: '120px',
        cellRenderer: DateFieldIndicator,
        cellRendererProps: { dateField: 'endDate' },
    },
    {
        field: 'assignee',
        header: 'Assignee',
        sortable: true,
        filterMethod: defaultFilterMethod,
        isFilterVisible: false,
        width: '120px',
    },
    {
        field: 'imageCount',
        header: 'Attachments',
        sortable: true,
        filterMethod: defaultFilterMethod,
        isFilterVisible: false,
        width: '100px',
    },
    {
        field: 'area',
        header: 'Area',
        sortable: true,
        filterMethod: defaultFilterMethod,
        isFilterVisible: false,
        width: '100px',
    },
    {
        field: 'length',
        header: 'Length',
        sortable: true,
        filterMethod: defaultFilterMethod,
        isFilterVisible: false,
        width: '100px',
    },
    {
        field: 'perimeter',
        header: 'Perimeter',
        sortable: true,
        filterMethod: defaultFilterMethod,
        isFilterVisible: false,
        width: '130px',
    },
];
